const filterMap = {
    All: () => true,
    Blog: (item) => item.tag.includes("Blog"),
    Article: (item) => item.tag.includes("Article"),
    Research: (item) => item.tag.includes("Research"),
};

export default filterMap;
